export const GepuSousCompetencesId: Record<string, string> = {
  0: "Collecte, transport, stockage et traitement des eaux pluviales des aires urbaines.",
};
